import promotions from '@/constants/promotions';
import PromotionsApi from '../../api/PromotionsApi';

const state = {
  promotion: null,
  promotionType: null,
  redeemed: null,
};

const getters = {
  isPromotionEligible: state => {
    if (state.promotionType === promotions.PROMOTION_TYPES.ONE_TIME && state.redeemed) {
      return false;
    }
    return true;
  },
};

const actions = {
  async fetchPromotion({ commit }, promoCode) {
    const promotion = await PromotionsApi.getPromotion(promoCode);
    if (promotion) {
      commit('setPromotion', promotion.name);
      commit('setPromotionType', promotion.promotionType);
      commit('setRedeemed', promotion.redeemed);
    }
  },
};

const mutations = {
  setPromotion(state, promotion) {
    state.promotion = promotion;
  },
  setPromotionType(state, promotionType) {
    state.promotionType = promotionType;
  },
  setRedeemed(state, redeemed) {
    state.redeemed = redeemed;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
